import { toast } from 'vue-sonner';
import type { AssistantSuggestion } from '~/types/models';

export type AssistantFeedbackRating = 'helpful' | 'not_helpful';
export type AssistantFeedbackSurface = 'workspace' | 'inbox' | 'prompted';

export function useAssistantFeedback() {
    const tenantStore = useTenantStore();
    const { $auth } = useNuxtApp();

    async function submitAssistantFeedback(input: {
        contextKey: string;
        suggestion: AssistantSuggestion;
        rating: AssistantFeedbackRating;
        surface: AssistantFeedbackSurface;
    }) {
        const tenantId = tenantStore.currentTenantId;
        const token = await $auth.currentUser?.getIdToken();
        if (!tenantId || !token) {
            throw new Error('Your session has expired. Please sign in again.');
        }
        await $fetch('/api/ai/feedback', {
            method: 'POST',
            headers: { authorization: `Bearer ${token}` },
            body: {
                tenantId,
                ...input,
            },
        });
        toast.message(input.rating === 'helpful'
            ? 'Thanks — this suggestion was marked helpful.'
            : 'Thanks — this suggestion was marked not helpful.');
    }

    return { submitAssistantFeedback };
}
